<template>
  <div class="wrap">
    <p class="wrapBase"></p>
    <div class="wrapNav">
      <img class="wrapBasetop" src="https://p1.ssl.qhimg.com/t01c4c4c5f00f1cbc3f.png" />
      <p class="wrapNavTitle">最新活动</p>
      <p class="wrapNavDesc">RECENT ACTIVITIES</p>
      <div class="wrapNavActive">
        <img class="wrapNavActiveImg" :src="nav.pic" alt="图片介绍" />
        <Btn :navArr="IscActive_2023" :pitchId="id" :style="styleBtn" @fetchNav="fetchNav" />
        <ul class="wrapNavActiveBar">
          <li
            class="wrapNavActiveBarList"
            :class="nav.id === item.id ? 'pitch' : ''"
            v-for="item in IscActive_2023"
            :key="item.id"
            @click="fetchNav(item.id)"
          >
            <p class="wrapNavActiveBarListNum">0{{ item.id + 1 }}</p>
            <p class="wrapNavActiveBarListTitle">{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <div
        v-for="item in IscActive_2023"
        :key="item.id"
        class="wrapDesc animate__animated animate__slideInRight"
        :class="item.id === id ? 'block ' : 'hidden'"
      >
        <p class="wrapDescTitle">{{ nav.desc_title }}</p>
        <p class="wrapDescNav">{{ nav.desc_nav }}</p>
        <p class="wrapDescNum">0{{ item.id + 1 }}</p>
        <p class="wrapDescMore" @click="toMore()">查看详情 ></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { IscActive_2023 } from '@/mock/2023isc/data.js'
import { ref } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const id = ref(0)
const nav = ref(IscActive_2023[id.value])
const styleBtn = {
  position: 'absolute',
  left: '0',
  top: '478px'
}
function toMore() {
  window.open(nav.value.moreUrl)
}
function fetchNav(newId) {
  id.value = newId
  nav.value = IscActive_2023[newId]
}
</script>

<style lang="scss" scoped>
.block {
  display: block;
}
.hidden {
  display: none;
}
.pitch {
  background: #00ab7a !important;
  color: #fff !important;
}
.wrap {
  position: relative;
  width: 100%;
  min-width: 1280px;
  background-size: cover;
  padding: 100px 0 49px;
  background-color: #fff;
  .wrapBase {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 414px;
    background: #f7f8fc;
    margin: 0;
  }
  &Nav {
    width: 1280px;
    margin: 0 auto;
    .wrapBasetop {
      position: absolute;
      top: -78px;
      right: 0;
      width: 532px;
      height: 314px;
    }
    &Active {
      position: relative;
      height: 700px;
      &Img {
        display: inline-block;
        width: 864px;
        height: 454px;
      }
      &Bar {
        position: absolute;
        top: 561px;
        margin: 0;
        &List {
          list-style: none;
          display: inline-block;
          width: 200px;
          padding: 16px 16px 28px;
          background-color: #fff;
          cursor: pointer;
          border-top: 8px solid transparent;
          &:hover {
            background: #e3fdf6;
            color: #00ab7a;
            border-top: 8px solid #00ab7a;
          }
          &Num {
            font-size: 30px;
            font-weight: bold;
          }
          &Title {
            font-size: 16px;
            line-height: 24px;
            margin-top: 20px;
          }
        }
      }
    }
    &Title {
      font-size: 40px;
      font-weight: bold;
      line-height: 32px;
      color: #00ab7a;
      margin: 0;
    }
    &Desc {
      font-size: 28px;
      line-height: 32px;
      color: #3d3d3d;
      margin: 12px 0 40px;
    }
  }
  &Desc {
    position: absolute;
    left: 808px;
    // top: 413px;
    bottom: 173px;
    width: calc(42vw);
    min-width: 512px;
    height: 363px;
    background: rgba(0, 171, 122, 0.96);
    color: #ffffff;
    padding: 48px 0px 44px 45px;
    border-radius: 40px 0 0;
    &Title {
      width: 432px;
      font-size: 20px;
      line-height: 32px;
      font-weight: bold;
    }
    &Nav {
      width: 432px;
      height: 112px;
      font-size: 16px;
      line-height: 28px;
      margin: 16px 0 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    // &Nav::after {
    //   content: '...';
    //   position: absolute;
    //   bottom: 0;
    //   right: 0;
    //   /*将省略号的大小设置为1个字体大小*/
    //   width: 1em;
    // }
    &Num {
      position: absolute;
      right: 15px;
      bottom: 15px;
      width: 120px;
      height: 120px;
      font-size: 100px;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.08);
      margin: 0;
    }
    &More {
      cursor: pointer;
      width: 148px;
      height: 48px;
      border-radius: 2px;
      background: #ffffff;
      font-size: 20px;
      line-height: 48px;
      color: #00ab7a;
      text-align: center;
    }
  }
}
</style>
